module.exports = __webpack_public_path__ + "static/media/parts_21.a34194cd.svg";